import { render, staticRenderFns } from "./view_order.vue?vue&type=template&id=8fa0d94a&scoped=true"
import script from "./view_order.vue?vue&type=script&lang=js"
export * from "./view_order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa0d94a",
  null
  
)

export default component.exports